import { PcNavigationItem } from 'app/shared/components/navigation';

export const defaultNavigation: PcNavigationItem[] = [
  {
    id: 'customer-support',
    title: 'CUSTOMER_SUPPORT',
    type: 'group',
    children: [
      {
        id: 'contact',
        title: 'Contactos',
        type: 'basic',
        link: '/customer-support/contacts',
        icon: 'mat_outline:person_add_alt',
      },
      {
        id: 'client',
        title: 'Cliente',
        type: 'basic',
        link: '/customer-support/clients',
        icon: 'heroicons_outline:identification',
      },
      {
        id: 'cutomer-group',
        title: 'Grupos',
        type: 'basic',
        link: '/customer-support/groups',
        icon: 'heroicons_outline:user-group',
      },
      {
        id: 'oportunity',
        title: 'Oportunidades',
        type: 'basic',
        link: '/customer-support/opportunities',
        icon: 'heroicons_outline:menu',
      },
    ],
  },
  {
    id: 'quotation',
    title: 'Cotización',
    type: 'group',
    children: [
      {
        id: 'products',
        title: 'Productos',
        type: 'basic',
        link: '/sales/products',
        icon: 'heroicons_outline:shopping-bag',
      },
      {
        id: 'quotes',
        title: 'Cotizaciones',
        type: 'basic',
        link: '/sales/quotes',
        icon: 'heroicons_outline:currency-dollar',
      },
    ],
  },
  {
    id: 'purchases',
    title: 'Compras',
    type: 'group',
    children: [
      {
        id: 'supplier',
        title: 'Proveedores',
        type: 'basic',
        link: '/purchases/suppliers',
        icon: 'mat_outline:list',
      },
    ],
  },
  {
    id: 'sales',
    title: 'Ventas',
    type: 'group',
    children: [
      {
        id: 'projects',
        title: 'Obras',
        type: 'basic',
        link: '/logistics/projects',
        icon: 'mat_outline:format_list_numbered',
      },
      {
        id: 'orders-processing',
        title: 'Procesadores de órdenes',
        type: 'basic',
        link: '/sales/orders-processing',
        icon: 'mat_outline:download_done',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Configuraciones',
    type: 'group',
    children: [
      {
        id: 'modules',
        title: 'Módulos',
        type: 'basic',
        link: '/settings/modules',
        icon: 'mat_outline:list_alt',
      },
      {
        id: 'roles',
        title: 'Roles',
        type: 'basic',
        link: '/settings/roles',
        icon: 'mat_outline:perm_data_setting',
      },
    ],
  },
];
export const compactNavigation: PcNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'Dashboards',
    tooltip: 'Dashboards',
    type: 'aside',
    icon: 'heroicons_outline:home',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'apps',
    title: 'Apps',
    tooltip: 'Apps',
    type: 'aside',
    icon: 'heroicons_outline:qrcode',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'pages',
    title: 'Pages',
    tooltip: 'Pages',
    type: 'aside',
    icon: 'heroicons_outline:document-duplicate',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'user-interface',
    title: 'UI',
    tooltip: 'UI',
    type: 'aside',
    icon: 'heroicons_outline:collection',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'navigation-features',
    title: 'Navigation',
    tooltip: 'Navigation',
    type: 'aside',
    icon: 'heroicons_outline:menu',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
export const futuristicNavigation: PcNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'DASHBOARDS',
    type: 'group',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'apps',
    title: 'APPS',
    type: 'group',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'others',
    title: 'OTHERS',
    type: 'group',
  },
  {
    id: 'pages',
    title: 'Pages',
    type: 'aside',
    icon: 'heroicons_outline:document-duplicate',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'user-interface',
    title: 'User Interface',
    type: 'aside',
    icon: 'heroicons_outline:collection',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'navigation-features',
    title: 'Navigation Features',
    type: 'aside',
    icon: 'heroicons_outline:menu',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
export const horizontalNavigation: PcNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'Dashboards',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'apps',
    title: 'Apps',
    type: 'group',
    icon: 'heroicons_outline:qrcode',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'pages',
    title: 'Pages',
    type: 'group',
    icon: 'heroicons_outline:document-duplicate',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'user-interface',
    title: 'UI',
    type: 'group',
    icon: 'heroicons_outline:collection',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'navigation-features',
    title: 'Misc',
    type: 'group',
    icon: 'heroicons_outline:menu',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
